<template>
    <a-row type="flex" class="individual_title_container">
      <div v-if="currentPath === '/individual/monitor'" class="map_title">
        <h4>監控地圖</h4>
        <p>{{carNo}}<span class="title_name">{{name}}</span></p>
      </div>
      <div v-else-if="currentPath === '/individual/schedule'">行程列表</div>
      <div v-else-if="currentPath.indexOf('/schedule/detail') !== -1" class="detail_title">
        <div @click="backToPrePage" class="list_back_btn">
          <img src="../../assets/icons/pre_page_arrow.svg" alt="">
        </div>
        行程資料
      </div>
      <div v-else-if="currentPath === '/individual/schedule/route'" class="detail_title points_title">
        <div @click="backToPrePage" class="list_back_btn">
          <img src="../../assets/icons/pre_page_arrow.svg" alt="">
        </div>
        點位資料
      </div>
      <div v-else-if="currentPath === '/individual/drivingReport'" class="detail_title">
        行駛報告
      </div>
      <div v-else>裝置資訊</div>
    </a-row>
</template>

<script>
import { mapState } from 'vuex';
  export default {
    name: 'IndividualInfoTitle',
    data() {
        return {
            currentPath: '/',
            name: '',
            carNo: '',
        }
    },
    mounted () {
        this.currentPath = this.$route.path;
        const { name, carNo } = this.identidyInfo;
        this.name = name;
        this.carNo = carNo;
    },
    methods: {
      backToPrePage() {

        const deviceUid = this.$route.query.data || '';

        // 若目前頁面在行程資料，返回到行程列表頁面
        // 若目前頁面在點位資料，且有資料(代表是從行程資料頁面點進來)，返回上一頁(行程資料)，否則返回到行程列表頁面
        // if (this.$route.path.indexOf('detail') !== -1) this.$router.go(-1);

        if (this.$route.path.indexOf('detail') !== -1){
          this.$router.push(`/individual/schedule?data=${encodeURIComponent(deviceUid)}`);
        } else if(sessionStorage.getItem('scheduleRoutePageFromPathName') === 'individualDetail') {
          this.$router.go(-1);

          // if (sessionStorage.getItem('scheduleRoutePageFromPathName') === 'individualDetail') this.$router.go(-1);
          // else this.$router.push(`/individual/schedule?data=${encodeURIComponent(deviceUid)}`);
        }else {
          this.$router.push(`/individual/schedule?data=${encodeURIComponent(deviceUid)}`);
        }
      }
    },
    computed: {
      ...mapState('identidyInfo', ['identidyInfo']),
      ...mapState('scheduleDetailData', ['scheduleDetailDataList']),
    },
  }
</script>

<style scoped lang="scss">
  .individual_title_container {
    position: relative;
    top: 53px;
    background-color: white;
    z-index: 9;
    height: 35px;
    // margin-bottom: 7px;
    >div {
      padding: 0 13px 12px 13px;
      font-size: 16px;
      line-height: 24px;
      font-weight: 700;
      color: #000000;
    }
    .points_title {
      padding-bottom: 20px;
    }

    .map_title {
      width: 100%;
      display: flex;
      justify-content: space-between;
      h4 {
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
        color: #000000;
        margin: 0;
      }
      p {
        margin: 0;
        font-weight: 400;
        color: #413435;
        .title_name {
          display: inline-block;
          margin-left: 8px;
        }
      }
    }
    .detail_title {
      display: flex;
      .list_back_btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        background: #FFFFFF;
        box-shadow: 0px 0px 0.8px rgba(0, 0, 0, 0.06), 0px 0px 2px rgba(0, 0, 0, 0.04), 0px 0px 5px rgba(0, 0, 0, 0.04), 0px 0px 17px rgba(0, 0, 0, 0.03);
        border-radius: 50%;
        border: 1px solid #FFFFFF;
        margin-right: 12px;
      }
    }
  }

</style>
